export default "__VITE_ASSET__DMQyiCIY__"